'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSelectedRange;

var _getSelectionStart = require('./get-selection-start');

var _getSelectionStart2 = _interopRequireDefault(_getSelectionStart);

var _getSelectionEnd = require('./get-selection-end');

var _getSelectionEnd2 = _interopRequireDefault(_getSelectionEnd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO can be utils function
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function getSelectedRange(dom) {
  var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _api$getSelectionEnd = api.getSelectionEnd,
      getSelectionEnd = _api$getSelectionEnd === undefined ? _getSelectionEnd2.default : _api$getSelectionEnd,
      _api$getSelectionStar = api.getSelectionStart,
      getSelectionStart = _api$getSelectionStar === undefined ? _getSelectionStart2.default : _api$getSelectionStar;


  return {
    start: getSelectionStart(dom),
    end: getSelectionEnd(dom)
  };
}